export default "svg {\n  height: 35rem;\n}";